<template>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
        <path fill="currentColor" fill-rule="evenodd"
            d="M10 2.625a7.375 7.375 0 1 0 0 14.75 7.375 7.375 0 0 0 0-14.75ZM1.375 10a8.625 8.625 0 1 1 17.25 0 8.625 8.625 0 0 1-17.25 0ZM10 6.04c.345 0 .625.28.625.625v3.333a.625.625 0 0 1-1.25 0V6.665c0-.345.28-.625.625-.625Zm0 6.666a.625.625 0 1 0 0 1.25h.008a.625.625 0 0 0 0-1.25H10Z"
            clip-rule="evenodd" />
    </svg>
</template>
